// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"41e16d3a","429":"e012df62","453":"e08d4134","710":"ff65882f","812":"6f5bb74e"}[chunkId] + ".chunk.js";
};